import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from 'reselect'
import { getMaxValue } from "../utils";

const initialState = null;


export const selectDisciplinesCurrentYear = createSelector(state => state.disciplines, disciplines =>
      //the current year is the max year from disciplines 
    disciplines?.filter(discipline => discipline.year == getMaxValue(disciplines, 'year')))


const disciplineSlice = createSlice({
    name: "disciplines",
    initialState,
    reducers: {
        init(state, action) {
            state =[...action.payload]
            return state;
        },
        add(state, action) {
            const parse = action.payload.additionalData && JSON.parse(action.payload.additionalData)
            const courseUpadte ={
                ...action.payload,
                backgroundImage: parse?.CardBackgroundImage,
                baseColor: parse?.baseColor,
            }
            return [...state, courseUpadte]
        },
        update(state,action){
            const parse = action.payload.additionalData && JSON.parse(action.payload.additionalData)
            const courseUpadte = {
                ...action.payload,
                backgroundImage: parse?.CardBackgroundImage,
                baseColor: parse?.baseColor,
             
            }
            return state.map(d => {
                if (d.id === action.payload.id)
                    return courseUpadte;
                return d;
            })
        },
        remove(state, action) {
            return state.filter(discipline => discipline.id !== action.payload)
        }
    }
})

export const disciplineAction = disciplineSlice.actions;
export default disciplineSlice;